import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'
import lang from '@/lang'

import LogoWhiteIcon from '@assets/images/logo/svg/logo-white.svg'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import theme from '@/theme'

const useStyles = makeStyles(theme => ({
  initialsIcon: {
    width: 52,
    height: 52,
    backgroundColor: theme.iconColor,
    borderRadius: '50%',
    justifyContent: 'center',
    color: theme.white,
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.fontSizes.large,
    fontWeight: theme.fontWeights.regular,
    [theme.devices.mobile]: {
      fontSize: theme.fontSizes.tiny,
    },
  },
  initialsIconDemo: {
    width: 52,
    height: 52,
    backgroundColor: theme.iconColor,
    borderRadius: '50%',
    justifyContent: 'center',
    color: theme.white,
    display: 'flex',
    alignItems: 'center',
  },
}))

const defaultIconColors = {
  background: theme.white,
  color: theme.textColor,
}
const TenantInitialsIcon = (props) => {
  const classes = useStyles()
  const {
    iconColors = defaultIconColors,
    tenantName,
    companyName,
    isDemo = false,
    customClass = {},
    icon = LogoWhiteIcon,
    onClick,
    hasConfirmedEmail = true,
    hasDanglingSubscriptions = false,
    hasInvites = false,
  } = props
  const [iconInitials, setIconInitials] = useState()

  const getInitials = (name) => {
    if (!name) return ''

    return name.split(' ').filter(Boolean).reduce((result, token) => {
      if (result.length < 2) {
        result += token[0]
      }
      return result
    }, '').toUpperCase()
  }

  const getDisplayName = ({ tenantName, companyName }) => {
    return tenantName || companyName || lang.tenant.newTenant
  }

  useEffect(() => {
    if (hasConfirmedEmail && !hasDanglingSubscriptions && !hasInvites) {
      const name = getInitials(getDisplayName({ tenantName, companyName }))
      setIconInitials(name)
    } else {
      setIconInitials('!')
    }
  }, [tenantName, companyName, hasConfirmedEmail, hasDanglingSubscriptions, hasInvites])

  return isDemo
    ? (<div className={clsx(classes.initialsIconDemo, customClass.initialsIconDemo)}><SVGIcon svg={icon} height='24x' width='24px' /></div>)
    : (<div className={clsx(classes.initialsIcon, customClass.initialsIcon)} style={iconColors} onClick={onClick}>{iconInitials}</div>)
}

TenantInitialsIcon.propTypes = {
  iconColors: PropTypes.object,
  tenantName: PropTypes.string,
  companyName: PropTypes.string,
  isDemo: PropTypes.bool,
  customClass: PropTypes.object,
  // passed on as <SVGIcon svg={icon} />; defaults to the LogoWhiteIcon component
  icon: PropTypes.oneOfType([PropTypes.elementType, PropTypes.element]),
  onClick: PropTypes.func,
  hasConfirmedEmail: PropTypes.bool,
  hasDanglingSubscriptions: PropTypes.bool,
  hasInvites: PropTypes.bool,
}

export default TenantInitialsIcon
